export const rURL = window.location.href + "calendar";
